import { useAuth } from "@/hooks/auth";
import { TypeUser } from "@/types/userType";
import { PageList as DistributionsPage } from "./Distributions";
import { PageList as SellersPage } from "./Sellers";
import { If } from "@/components/If";
import { usePermissions } from "@/hooks/usePermissions";

export type TableDataProps = {
  id: number;
  uuid: string;
  name: string;
  validation_date: string;
  lottery_id: number;
  is_active: boolean;
  tenant_id: number;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
  lottery: {
    id: number;
    name: string;
  };
  tenant: {
    id: number;
    name: string;
  };
  product_classifications: {
    id: number;
    contest_id: number;
    lottery_id: number;
    product_name: string;
    product_classification_id: number;
    tenant_id: number;
    created_at: string;
    updated_at: string;
    lottery: {
      id: number;
      name: string;
    };
    product_classification: {
      id: number;
      uuid: string;
      lottery_id: number;
      name: string;
      game_quantity: number;
      dez_quantity: number;
      quota_quantity: number;
      total_without_tariff: number;
      total_with_tariff: number;
      game_percentage: number;
      tariff: number;
      sale_price: number;
      price_without_tariff: number;
      commission_by_quote: number;
      image: string | null;
      is_active: number;
      product_type_id: number;
      tenant_id: number;
      created_at: string;
      updated_at: string;
      deleted_at: string | null;
    };
  }[];
};

export const PageList = () => {
  const { user } = useAuth();
  const userTypeId = user?.user_type?.id;
  const { hasPermission } = usePermissions();

  if (userTypeId == TypeUser.client) {
    return (
      <If condition={hasPermission("view-distributions-list")}>
        <DistributionsPage />
      </If>
    );
  }

  if (userTypeId == TypeUser.unity_responsible || userTypeId == TypeUser.stockist) {
    return (
      <If condition={hasPermission("view-distributions-list")}>
        {/* <UnitiesPage /> */}
        <SellersPage />
      </If>
    );
  }

  return null;
};
